import { graphql } from '../../gql'

export const SET_CURRENT_ORGANIZATION = graphql(/* GraphQL */ `
  mutation AccountSetCurrentOrganization($organizationId: String) {
    accountSetCurrentOrganization(organizationId: $organizationId)
  }
`)

export const DISMISS_BANNER = graphql(/* GraphQL */ `
  mutation DismissBanner($banner: String!) {
    dismissBanner(banner: $banner) {
      ... on DismissBannerResponse {
        success
      }
      ... on DismissBannerError {
        cause
      }
    }
  }
`)

export const DISMISS_OBJECT = graphql(/* GraphQL */ `
  mutation DismissObject(
    $organizationId: String!
    $dismissedObject: DismissedObjectInput!
  ) {
    addOrUpdateDismissedObject(
      organizationId: $organizationId
      dismissedObject: $dismissedObject
    ) {
      ... on AddOrUpdateDismissedObjectResponse {
        success
      }
      ... on AddOrUpdateDismissedObjectError {
        cause
        userFriendlyMessage
      }
    }
  }
`)

export const QUERY_ACCOUNT = graphql(/* GraphQL */ `
  query Account {
    account {
      id
      preferences {
        startOfWeek
      }
      channels {
        id
        name
        organizationId
        isLocked
        serverUrl
        allowedActions
        type
        service
        serviceId
      }
      email
      name
      hasVerifiedEmail
      helpScoutBeaconSignature
      avatar
      createdAt
      featureFlips
      isImpersonation
      shouldShowEmailVerificationCommunication
      dismissedBanners
      hellonextSsoToken
      currentOrganization {
        id
        name
        allowedActions
        channelRecommendations
        role
        members {
          totalCount
        }
        settings {
          enforce2FA
        }
        shouldEnforce2FASetup
        createdAt
        isOneBufferOrganization
        channelLimit
        isBetaEnabled
        isAlphaEnabled
        lifetimeConnectedChannelsCount {
          service
          serviceIds
        }
        dismissedObjects {
          id
        }
        commonTrackingProperties {
          atEventBillingState
          atEventBillingPlan
          atEventBillingCycle
          atEventBillingGateway
          atEventIsNewBuffer
          atEventChannelQty
        }
        shouldDisplayInviteCTA
        featureFlips
        channels {
          id
          avatar
          name
          service
          serviceId
          type
          organizationId
          isLocked
          createdAt
          shouldShowPinterestUpgradeBanner
          shouldShowLinkedInUpgradeBanner
          shouldShowTiktokUpgradeBanner
          shouldShowIgLoginRefreshBanner
          serverUrl
          apiVersion
          postingSchedule {
            day
            times
            paused
          }
        }
        ownerEmail
        shouldShowTeamMemberOrganizationDowngradedBanner
        billing {
          id
          canAccessAnalytics
          canAccessEngagement
          canAccessPublishing
          paymentDetails {
            hasPaymentDetails
            creditCard {
              brand
              last4
              expMonth
              expYear
            }
            paymentMethod
          }
          isAutomaticTaxEnabled
          taxDetails {
            automaticTax
          }

          ... on MPBilling {
            taxExempt
            billingRedirectUrl
            subscriptions {
              interval
              plan
              product
              trial {
                isActive
              }
            }
          }
          ... on OBBilling {
            canStartTrial
            hasNeverBeenPayingCustomer
            taxExempt
            subscription {
              quantity
              interval
              periodEnd
              isCanceledAtPeriodEnd
              trial {
                isActive
                remainingDays
                isAwaitingUserAction
                startDate
                endDate
              }
              plan {
                id
                name
              }
              isPaymentPastDue
              startDate
            }
            gateway {
              gatewayType
              gatewayId
              gatewayPlatform
            }
            channelSlotDetails {
              flatFee
              currentQuantity
              chargableQuantity
              pricePerQuantity
              minimumQuantity
            }
            pricingTiers {
              flatFee
              unitPrice
              upperBound
            }
          }
        }
      }
      organizations {
        id
        name
        channelRecommendations
        members {
          totalCount
        }
        settings {
          enforce2FA
        }
        shouldEnforce2FASetup
        allowedActions
        role
        createdAt
        isOneBufferOrganization
        isBetaEnabled
        ownerEmail
        dismissedObjects {
          id
        }
        commonTrackingProperties {
          atEventBillingState
          atEventBillingPlan
          atEventBillingCycle
          atEventBillingGateway
          atEventIsNewBuffer
          atEventChannelQty
        }
        shouldDisplayInviteCTA
        featureFlips
        channels {
          id
          avatar
          name
          service
          serviceId
          organizationId
          isLocked
          shouldShowPinterestUpgradeBanner
          shouldShowLinkedInUpgradeBanner
          serverUrl
        }
        billing {
          id
          canAccessAnalytics
          canAccessEngagement
          canAccessPublishing
          paymentDetails {
            hasPaymentDetails
            creditCard {
              brand
              last4
              expMonth
              expYear
            }
          }
          isAutomaticTaxEnabled
          taxDetails {
            automaticTax
          }

          ... on MPBilling {
            taxExempt
            billingRedirectUrl
            subscriptions {
              interval
              plan
              product
              trial {
                isActive
              }
            }
          }
          ... on OBBilling {
            canStartTrial
            hasNeverBeenPayingCustomer
            taxExempt
            subscription {
              quantity
              interval
              periodEnd
              isCanceledAtPeriodEnd
              trial {
                isActive
                remainingDays
                isAwaitingUserAction
                startDate
                endDate
              }
              plan {
                id
                name
              }
              isPaymentPastDue
              startDate
            }
            gateway {
              gatewayType
              gatewayId
            }
            channelSlotDetails {
              flatFee
              currentQuantity
              chargableQuantity
              pricePerQuantity
              minimumQuantity
            }
          }
        }
      }
      products {
        name
        userId
      }
    }
  }
`)

export const SEND_TEST_NOTIFICATION = graphql(/* GraphQL */ `
  mutation SendTestNotification {
    sendTestNotification {
      ... on SendTestNotificationError {
        code
      }
    }
  }
`)
